<app-page-header
  class="header"
  [inside]="true"
  [backSwipe]="backSwipeConfig"
  (backButtonClick)="back.emit()"
/>

<div class="top">
  <span class="big">GIFT CARDS</span>
  <span class="top__text">THE PERFECT PRESENT FOR SPORTS AND ENTERTAINMENT FANS ALIKE, REAL SPORTS GIFT CARDS OFFER ACCESS TO EXCEPTIONAL EXPERIENCES AND SERVICES.</span>
  <span class="top__text">PURCHASE, VIEW BALANCE & REGISTER YOUR CARD</span>
  <app-qrcode content="https://oon.gl/FnNrGZ" [size]="340"/>
</div>

